import { CoachSettings, WebSettings } from "@/interfaces";
import { useAccountSettings, usePlayerSettings, useSocialCoachSession } from "@/utils";

export const useReputationManagementAvailable = (playerId: number | null | undefined): boolean | undefined => {
  const { coachId } = useSocialCoachSession();
  const { hasAccountSetting, accountPermissionsLoading } = useAccountSettings(coachId);
  const { hasSetting: hasPlayerSetting } = usePlayerSettings(playerId);
  const playerHasReputationManagement = playerId ? hasPlayerSetting(CoachSettings.PLAYER_REPUTATION_MANAGEMENT) : true;

  if (accountPermissionsLoading || playerHasReputationManagement === undefined) return undefined;
  return hasAccountSetting(WebSettings.REPUTATION_MANAGEMENT) && playerHasReputationManagement;
};
